import ProgramSelectedModalContainer from './containers/ProgramSelectedModalContainer'

export default ProgramSelectedModalContainer
